import { Module } from '@nestjs/common';
import { OvertimeCategoryController } from './overtime-category.controller';
import { OvertimeCategoryService } from './overtime-category.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { OverTimeCatAdapter } from './dto/overtime-category.adapter';
import { OverTimeCategory } from './overtime-category.entity';
import {ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages'
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports: [
    TypeOrmModule.forFeature([OverTimeCategory]),
  ],
  controllers: [OvertimeCategoryController],
  providers: [OvertimeCategoryService, OverTimeCatAdapter, ApplicationExceptionHandler,LogsService],
  exports: [OvertimeCategoryService]
})
export class OvertimeCategoryModule {}
